import { ShieldCheck, Building2, CalendarOff, Users, Settings } from "lucide-react";

export const NOTIF_MODULES = [
  { key: "employees", icon: ShieldCheck, grad: "from-teal-500 to-emerald-600", soft: "bg-teal-50 text-teal-800 border-teal-200", titleKey: "notifmod_employees", descKey: "notifmod_employees_desc" },
  { key: "licenses", icon: Building2, grad: "from-indigo-500 to-fuchsia-600", soft: "bg-fuchsia-50 text-fuchsia-800 border-fuchsia-200", titleKey: "notifmod_licenses", descKey: "notifmod_licenses_desc" },
  { key: "dayoff", icon: CalendarOff, grad: "from-amber-500 to-orange-600", soft: "bg-amber-50 text-amber-800 border-amber-200", titleKey: "notifmod_dayoff", descKey: "notifmod_dayoff_desc" },
  { key: "empmgmt", icon: Users, grad: "from-sky-500 to-blue-600", soft: "bg-sky-50 text-sky-800 border-sky-200", titleKey: "notifmod_empmgmt", descKey: "notifmod_empmgmt_desc" },
  { key: "system", icon: Settings, grad: "from-slate-500 to-slate-700", soft: "bg-slate-100 text-slate-700 border-slate-200", titleKey: "notifmod_system", descKey: "notifmod_system_desc" },
];

export const notifModule = (key) => NOTIF_MODULES.find((m) => m.key === key) || NOTIF_MODULES[4];

export const PRIORITY_STYLES = {
  critical: "bg-rose-600 text-white",
  high: "bg-rose-100 text-rose-700",
  medium: "bg-amber-100 text-amber-800",
  low: "bg-slate-100 text-slate-600",
};

export const PRIORITY_ORDER = { critical: 0, high: 1, medium: 2, low: 3 };
